import { useState, useEffect } from 'react';
import { Address } from '../../user/types/type';
import dataProvider from '../../services/api';

interface UseAddressesProps {
  userId: number | null;
  handleErrorWithLogout: (error: any) => void;
}

export const useAddresses = ({ userId, handleErrorWithLogout }: UseAddressesProps) => {
  const [addresses, setAddresses] = useState<Address[]>([]);

  const fetchAddresses = async (userId: number) => {
    try {
      const { data } = await dataProvider.getUserAddresses({ userId });
      setAddresses(data);
    } catch (error: any) {
      handleErrorWithLogout(error);
      setAddresses([]);
    }
  };

  useEffect(() => {
    if (userId) {
      fetchAddresses(userId);
    } else {
      setAddresses([]);
    }
  }, [userId]);

  const primaryAddress = addresses.find(address => address.isPrimary);

  return {
    addresses,
    primaryAddress,
    refetchAddresses: userId ? () => fetchAddresses(userId) : () => {},
  };
};